var _circle, _path, _path2, _path3, _path4, _g, _g2, _circle2, _g3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 803",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.263,
    height: 65.661,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 49",
    cx: 13.937,
    cy: 13.937,
    transform: "translate(6.061)",
    fill: "#040000",
    r: 13.937
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 454",
    fill: "#040000",
    d: "M15.949 24.617h8.249v16.498h-8.249z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 455",
    fill: "#040000",
    d: "M18.184 35.149h3.665v12.078h-3.665z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 456",
    fill: "#040000",
    d: "M15.197 30.368h9.753v2.498h-9.753z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 457",
    fill: "#040000",
    d: "M15.197 39.335h9.753v2.498h-9.753z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 201",
    d: "M38.608 65.065s2.711-9.934 1.194-13.383c-1.444-3.28-8.837-8.984-8.837-8.984l-3.591-.427.358 3.108 1.954.124s6.693 4.751 7.8 7.275c1.056 2.4-.913 12.045-.913 12.045z",
    fill: "#040000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 801"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M1.656 65.065S-1.056 55.131.462 51.682c1.444-3.28 8.837-8.984 8.837-8.984l3.591-.427-.357 3.108-1.954.124s-6.693 4.751-7.8 7.275c-1.056 2.4.913 12.045.913 12.045z",
    fill: "#040000"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 50",
    cx: 9.059,
    cy: 9.059,
    transform: "translate(10.94 4.879)",
    fill: "#040000",
    stroke: "#fff",
    strokeMiterlimit: 10,
    r: 9.059
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 802"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 203",
    d: "M14.06 35.349l-1.937 8.981 5.113 1.858h5.675l5.113-1.858-1.937-8.981z",
    fill: "none",
    stroke: "#040000",
    strokeMiterlimit: 10,
    strokeWidth: 3.524
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 204",
    d: "M17.999 64.425l.819-10.413-.007-8.839h2.282l.007 8.842.838 10.411-1.864 1.239z",
    fill: "#040000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineMulti);
export default __webpack_public_path__ + "static/media/machineMulti.f0866947d2fd4559.svg";
export { ForwardRef as ReactComponent };